import { User } from 'lucide-react';
import { ActivityItem, formatDatumZeit, interaktionInfo } from '@elbklar/ui';
import type { Interaction } from '@/types';

interface TimelineProps {
  interactions: Interaction[];
}

export function Timeline({ interactions }: TimelineProps) {
  if (interactions.length === 0) {
    return <div className="py-8 text-center text-muted-foreground">Interaktionen mit diesem Kontakt erscheinen hier, sobald eine angelegt ist.</div>;
  }

  return (
    <div>
      {interactions.map((interaction, index) => {
        const art = interaktionInfo(interaction.type);
        return (
          <ActivityItem
            key={interaction.id}
            type={art.type}
            last={index === interactions.length - 1}
            title={interaction.subject}
            meta={`${art.label} · ${formatDatumZeit(interaction.occurred_at)}`}
          >
            {interaction.description && <p className="whitespace-pre-wrap t-small">{interaction.description}</p>}
            {interaction.contact_name && (
              <div className="mt-2 flex items-center gap-1 t-small">
                <User size={12} strokeWidth={1.75} aria-hidden />
                <span>{interaction.contact_name}</span>
              </div>
            )}
          </ActivityItem>
        );
      })}
    </div>
  );
}
